import { CacheResolverMap } from 'apollo-cache-inmemory';

export default {
  Query: {
    car: (_, args, { getCacheKey }) =>
      getCacheKey({ __typename: 'Car', id: args.id }),
  },
} as CacheResolverMap;
